import { DataGridWithCheckbox, type DataGridWithCheckboxProps } from '@shared/components';

export type BaseAdminExamCourseEnablementDataGridProps = Omit<
  DataGridWithCheckboxProps,
  'rowHeight' | 'disableColumnMenu' | 'sx'
>;

export default function BaseAdminExamCourseEnableMentDataGrid(
  props: Readonly<BaseAdminExamCourseEnablementDataGridProps>,
) {
  return (
    <DataGridWithCheckbox
      {...props}
      rowHeight={48}
      disableColumnMenu
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
        },
        '.MuiButtonBase-root': {
          p: theme.spacing(0),
        },
        '.MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
          display: 'none',
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          px: theme.spacing(3),
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
